// Admin → Growth callables (functions/growth). Admin-only on the server.
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

const call = async (name, data = {}) => {
  try {
    return (await httpsCallable(getFunctions(getApp()), name, { timeout: 310000 })(data)).data;
  } catch (e) {
    const err = new Error(e?.message?.replace(/^(FirebaseError:\s*)?/, '') || 'Something went wrong.');
    err.code = e?.code;
    throw err;
  }
};

export const getGrowthOverview = () => call('adminGrowthOverview');
export const growthAction = (action, payload = {}) => call('adminGrowthAction', { action, ...payload });
export const saveGrowthSettings = (settings) => call('adminGrowthSettings', { settings });
export const runGrowthJob = (job) => call('adminGrowthRun', { job });
